import { render, staticRenderFns } from "./GroupEditTabAccount.vue?vue&type=template&id=5aaaf6c8"
import script from "./GroupEditTabAccount.vue?vue&type=script&lang=js"
export * from "./GroupEditTabAccount.vue?vue&type=script&lang=js"
import style0 from "./GroupEditTabAccount.vue?vue&type=style&index=0&id=5aaaf6c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports